import $store, { spaceLettersSelector, SpaceType } from "../../../../../store";

import { SpaceNumberMarkerDecoration } from "./SpaceNumberMarkerDecoration";

export class LetterSpaceNumberMarkerDecoration extends SpaceNumberMarkerDecoration {

  spaceLetter(space: SpaceType) {
    return spaceLettersSelector($store.getState())[space.id];
  }

  textContent(space: SpaceType): string {
    return this.spaceLetter(space);
  }

  // We don't know the content length when serializing,
  // as it depends on the space, so return a fixed length
  textContentLength(_space?: SpaceType) {
    return 1;
  }
}
